import { inject, Injectable } from '@angular/core';
import { DefaultTranspiler, TranspileParams, TRANSLOCO_TRANSPILER } from '@jsverse/transloco';
import { MessageFormatTranspiler, TRANSLOCO_MESSAGE_FORMAT_CONFIG } from '@jsverse/transloco-messageformat';

const ICU_EXPRESSION = /\{\s*\w+\s*,\s*(plural|select|selectordinal)\s*,/;

/**
 * Wendet MessageFormat nur auf Übersetzungen mit ICU-Ausdruck an. Alle übrigen
 * laufen über den Standard-Transpiler, damit Platzhalter wie ${variable} in den
 * ag-Grid-Übersetzungen erhalten bleiben.
 */
@Injectable()
export class IcuTranspiler extends DefaultTranspiler {
  private readonly messageFormatTranspiler = inject(MessageFormatTranspiler);

  override transpile(params: TranspileParams): any {
    if (typeof params.value === 'string' && ICU_EXPRESSION.test(params.value)) {
      return this.messageFormatTranspiler.transpile(params);
    }

    return super.transpile(params);
  }

  onLangChanged(lang: string): void {
    this.messageFormatTranspiler.onLangChanged(lang);
  }
}

export const icuTranspiler = [
  MessageFormatTranspiler,
  {
    provide: TRANSLOCO_MESSAGE_FORMAT_CONFIG,
    useValue: { locales: 'de' }
  },
  {
    provide: TRANSLOCO_TRANSPILER,
    useClass: IcuTranspiler
  }
];
